const colors = {
    brand: {
        primary: '#1565C8',
        primaryContainer: '#D6E3FF',
        onPrimaryContainer: '#001B3F',
    },
    text: {
        dark: '#0E2348',
        light: '#545F71',
    },
    background: {
        white: '#ffffff',
        offWhite: '#EEF3F9',
        dark: '#0A1424',
    },
    border: {
        default: '#D6E3FF',
    },
    success: {
        main: '#1F8A56',
    },
    error: {
        text: '#BA1A1A',
        border: '#FFDAD6',
        background: '#FFF5F4',
    },

    status: {
        success: { background: '#D7F0E0', text: '#1F8A56', dot: '#1F8A56' },
        warning: { background: '#FFDDB3', text: '#8A5300', dot: '#E68A06' },
        info: { background: '#D6E3FF', text: '#1565C8', dot: '#1565C8' },
        error: { background: '#FFDAD6', text: '#BA1A1A', dot: '#BA1A1A' },
        neutral: { background: '#ECF1F8', text: '#545F71', dot: '#717C96' },
    },

    chip: {
        selectedBackground: '#D6E3FF',
        selectedText: '#1565C8',
        outlineBorder: '#C3CAD9',
        hotBackground: '#FFDDB3',
        hotText: '#8A5300',
    },

    // Call center. One definition for values that were redeclared in eight
    // files (callStates.js, CallConsole, SoftphoneDock, SupervisorConsole and
    // the four telephony settings pages), which is why THEME_BLUE and
    // CARD_BORDER had drifted into three different greys.
    callCenter: {
        danger: '#C62828',
        dangerHover: '#B71C1C',
        surface: '#F4F6F9',
        surfaceHover: '#E8EDF5',
        muted: '#5C6B82',
        disabled: '#C9D4E5',
        activeBackground: '#D6E3FF',
        activeHover: '#C3D6FF',
        activeText: '#1565C8',
        cardBorder: '#E6E8F0',
        dark: '#0E2348',
        themeBlue: '#1565C8',
        themeBlueHover: '#0D47A1',
    },

    // PearlCRM login page — gold + navy brand palette
    loginBrand: {
        gold1: '#FFD45C',
        gold2: '#FFB400',
        gold3: '#E68A06',
        goldGradient: 'linear-gradient(135deg, #FFD45C 0%, #FFB400 46%, #E68A06 100%)',

        accent: '#1565C8',
        accentInk: '#0E2348',
        accentSoft: 'rgba(21, 101, 200, 0.11)',

        navyGradient: 'linear-gradient(155deg, #193F8C 0%, #16266B 52%, #0E2348 100%)',

        ink: '#001B3F',
        ink2: '#545F71',
        muted: '#677384',
        line: 'rgba(14, 35, 72, 0.12)',

        cream: '#EEF4FF',
        surface: '#F7FAFD',
        surface2: '#FFFFFF',
        surfaceContainerLowest: '#FFFFFF',
        surfaceContainer: '#ECF1F8',
        surfaceContainerHighest: '#E0E7F0',
        surfaceVariant: '#DFE3EC',
        onSurface: '#112A52',
        onSurfaceVariant: '#46587A',
        outline: '#717C96',
        outlineVariant: '#C3CAD9',
    },
};

export default colors;
